import React from 'react';

import { useAuth } from '../../../app/AuthorizationProvider';
import { LoadingOverlay } from '../../LoadingOverlay';

export const Logout: React.FC = () => {
  const { logout } = useAuth();

  logout();

  return <LoadingOverlay loading />;
};
